import { JsonLd, MetaData, SpecialistPage } from '@/components'
import { useHost } from '@/contexts/HostContext'
import { buildPhysicianSchema } from '@/lib/schema'
import { getCanonicalUrl } from '@/lib/locales'
import { useRouter } from 'next/router'

export default function NextSpecialistPage(props) {
  const { first_name, last_name, patronymic, position, qualification, meta } = props
  const { title: titleFromProps, description: descFromProps } = meta
  const title =
    titleFromProps ||
    `${last_name || ''} ${first_name || ''} ${patronymic || ''}. ${position || ''}. ${qualification || ''}`
  const description = descFromProps
  const host = useHost()
  const router = useRouter()
  const pageUrl = getCanonicalUrl(router?.asPath || '/', host)
  const physicianSchema = buildPhysicianSchema(props, {
    host,
    asPath: router?.asPath,
    pageUrl,
  })

  return (
    <>
      <MetaData title={title} description={description} />
      <JsonLd data={physicianSchema} />
      <SpecialistPage {...props} />
    </>
  )
}

NextSpecialistPage.getInitialProps = async ({ query, api }) => {
  const { specialistSlug, ...otherQueries } = query

  const response = await api.specialist({ slug: specialistSlug, ...otherQueries })

  const { data } = response

  return { ...data, pageType: 'specialist' }
}
